import Nullstack from 'nullstack';
export default function IconBackhoe({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-backhoe",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "13",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "19",
    x2: "4",
    y2: "19"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "15",
    x2: "13",
    y2: "15"
  }), "   ", Nullstack.element("path", {
    d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
  }), "   ", Nullstack.element("path", {
    d: "M5 15v-2a1 1 0 0 1 1 -1h7"
  }), "   ", Nullstack.element("path", {
    d: "M21.12 9.88l-3.12 -4.88l-5 5"
  }), "   ", Nullstack.element("path", {
    d: "M21.12 9.88a3 3 0 0 1 -2.12 5.12a3 3 0 0 1 -2.12 -.88l4.24 -4.24z"
  }), " ");
}